import { SeoService } from '../services'

export const useSeo = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(SeoService)
    },
  }
}
